import { hasKeysOfUnknown, isObject } from '../guards'
import type { ParsedToken } from './parsedToken'

export function parseToken(token: string): ParsedToken {
  const base64Url = token.split('.')[1]
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(char => `%${char.charCodeAt(0).toString(16).padStart(2, '0')}`)
      .join(''),
  )

  const parsed: unknown = JSON.parse(jsonPayload)
  assertIsParsedToken(parsed)
  return parsed
}

const requiredKeys = ['sub', 'email_verified', 'preferred_username']
const optionalKeys = [
  'exp',
  'iat',
  'jti',
  'iss',
  'aud',
  'typ',
  'azp',
  'nonce',
  'session_state',
  'acr',
  'realm_access',
  'scope',
  'email_verified',
  'name',
  'preferred_username',
  'given_name',
  'family_name',
  'email',
]

function assertIsParsedToken(jsonPayload: unknown): asserts jsonPayload is ParsedToken {
  if (isObject(jsonPayload)) {
    if (!hasKeysOfUnknown(jsonPayload, ...optionalKeys)) {
      console.debug('Не все опциональные ключи присутствуют в JWT')
    }

    if (hasKeysOfUnknown(jsonPayload, ...requiredKeys)) {
      return
    }
  }

  throw new Error('неверный token')
}
